import { render, staticRenderFns } from "./SignifiCalls.vue?vue&type=template&id=7276a620&scoped=true&"
import script from "./SignifiCalls.vue?vue&type=script&lang=js&"
export * from "./SignifiCalls.vue?vue&type=script&lang=js&"
import style0 from "./SignifiCalls.vue?vue&type=style&index=0&id=7276a620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7276a620",
  null
  
)

export default component.exports